import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, notification, Divider, message } from 'antd';
import { push } from 'connected-react-router';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

// Local
import Text from 'components/Text';
import { post } from 'library/endpoints';

/**
 * Activate
 * @param {*} props 
 * @returns 
 */
const Activate = (props) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.auth.token) {
      props.push('/')
    }
  }) 

  useEffect(() => {
    if (props.auth.token) {
      props.push('/')
    }
  }, [props.auth]) // eslint-disable-line

  const [form, setForm] = useState({
    password_confirm: null,
    password: null,
  })

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length > 4 && form.password_confirm !== form.password) {
      // Error
      notification.error({
        message: 'Erreur',
        description: props.t('Admin.Auth.Activation.SubmitError', 'Erreur lors de la soumission de vos informations')
      }); 
    } else {
      try {
        setLoading(true)
        await post(`/frontend/auth/activate`, {...form, activationToken: props.match.params.activationCode});
        setLoading(false)
        message.success('Votre mot de passe a bien été enregistré')
        props.push('/')
      } catch (err) {
        console.log(err)
        setLoading(false)
        message.error('Une erreur s est produite, veuillez réessayer')
      }

    }
  }
  
  return (
    <>
      <form style={{ width: 400, margin: 'auto', marginTop: 40 }} onSubmit={handleOnSubmit}>
        <h1>{props.t('Admin.Auth.Activation.Title', 'Activation de votre compte')}</h1>


        {
          form.password && form.password.length < 8 && (
            <Text color="red">{props.t('Admin.Auth.Activation.PasswordLengthError', 'Votre mot de passe doit contenir au moins 8 caractères')}</Text>            
          )
        }

        {
          form.password && form.password.length > 7 && form.password !== form.password_confirm && (
            <Text color="red">{props.t('Admin.Auth.Activation.PasswordConfirm', 'Vos deux mots de passe ne sont pas identiques')}</Text>            
          )
        }

        <div style={{ height: 20 }} />

        {props.t('Admin.Auth.Activation.Password', 'Mot de passe')}
        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password: e.target.value})} minLength={8}/>

        <div style={{ height: 20 }} />

        {props.t('Admin.Auth.Activation.PasswordConfirm', 'Confirmation de mot de passe')}

        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password_confirm: e.target.value})} minLength={8}/>

        <div style={{ height: 20 }} />

        {
          loading && (
            <Text style={{ marginBottom: 10 }} align="center">Chargement en cours, veuillez patientez quelques instants...</Text>
          )
        }

        <Button 
          type="primary" 
          htmlType="submit" 
          disabled={!form.password || (form.password !== form.password_confirm) || form.password.length < 4}
          loading={loading}
        >
          {props.t('Admin.Auth.Activation.Button', 'Activer mon compte')}
        </Button>
      </form>

      <Divider>ou</Divider>
      
      <Text align="center">
        <Link to={`/`}>{props.t('Admin.Auth.Activation.LoginLink', `S'identifier`)}</Link>
      </Text>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Activate));